export default __webpack_public_path__ + "static/InterDisplay-SemiBold-255f21aab3083c164d483ce92a3759ba.woff";